import { AIRPORT_OPTIONS, airportValue } from '../airportOptions';

export default function AirportInput({ id, label, value, onChange, required = true }) {
  const listId = `${id}-airport-options`;

  return (
    <label className="swp-field">
      <span>{label}</span>
      <input
        id={id}
        type="text"
        list={listId}
        placeholder="City or airport code"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoComplete="off"
        required={required}
      />
      <datalist id={listId}>
        {AIRPORT_OPTIONS.map((airport) => (
          <option
            key={airport.code}
            value={airportValue(airport)}
            label={`${airport.code} — ${airport.name}`}
          />
        ))}
      </datalist>
    </label>
  );
}
